// extracted by mini-css-extract-plugin
export default {"container":"Invite_container__FZhLB","boxLink":"Invite_boxLink__gwuO4","copy":"Invite_copy__1nvmK"};